import {Routes} from '@angular/router';
import {PageNotFoundPage, StationNotLoadedPage} from '@splixer/player-ui';
import {StationHomePage} from './pages/station/kexp-home.page';

export const appRoutes: Routes = [
  {
    path: '',
    component: StationHomePage,
    children: [
      {
        path: 'station_error',
        component: StationNotLoadedPage
      },
      {
        path: 'library',
        data: {
          breadcrumb: {
            label: 'Library'
          }
        },
        loadChildren: () => import('./pages/station/listen/library.routes').then((m) => m.routes)
      },
      {
        path: 'np',
        data: {
          breadcrumb: {
            label: 'Playlist'
          }
        },
        loadChildren: () => import('./pages/station/playlist/now-playing.routes').then((m) => m.routes)
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'library'
      }
    ]
  },
  {path: '**', component: PageNotFoundPage}
];
